import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import PaddedDivider from 'components/PaddedDivider';
import ArrowRightIcon from 'mdi-material-ui/ArrowRight';

const alignFlex = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
  default: 'flex-start'
};

const HelpContact = ({ text, button, align, hideDivider }) => (
  <Grid container spacing={16} justify={alignFlex[align || 'default']}>
    <Grid item xs={12}>
      {!hideDivider && <PaddedDivider />}
      <Typography variant="h6" align={align}>
        {text}
      </Typography>
    </Grid>
    <Grid item>
      <Button
        href={button.href}
        variant="contained"
        size="large"
        color="primary"
      >
        {button.title} <ArrowRightIcon />
      </Button>
    </Grid>
  </Grid>
);

export default HelpContact;
